<main id="main-content" class="container">
    <h1 class="text-center" i18n>Contáctanos</h1>
    <div class="form" *ngIf="newContact">
        <div class="mb-3">
            <label for="name" class="form-label"><span i18n>Nombre y apellidos:</span><span
                    class="required">*</span></label>
            <input type="text" class="form-control" id="name" i18n-placeholder placeholder="Tu nombre y apellidos"
                [(ngModel)]="newContact.name" required />
        </div>
        <div class="mb-3">
            <label for="email" class="form-label"><span i18n>Correo electrónico:</span><span
                    class="required">*</span></label>
            <input type="email" class="form-control" id="email" i18n-placeholder placeholder="Tu correo electrónico"
                [(ngModel)]="newContact.email" required />
        </div>
        <div class="mb-3">
            <label for="municipality" class="form-label" i18n>Municipio:</label>
            <select id="municipality" class="form-select" [(ngModel)]="newContact.municipality">
                <option value="" i18n>Selecciona un Municipio (opcional)</option>
                @for (municipality of municipalities; track municipality) {
                <option value="{{municipality.municipality.municipalityName}}">
                    {{municipality.municipality.municipalityName}}</option>
                }
            </select>
        </div>
        <div class="mb-3">
            <label for="n-exp" class="form-label" i18n>Nº. Expediente:</label>
            <input type="text" class="form-control" id="n-exp" i18n-placeholder
                placeholder="Pon número de expediente (opcional)" [(ngModel)]="newContact.record" />
        </div>
        <div class="mb-3">
            <label for="consulta" class="form-label"><span i18n>Tipo de consulta:</span><span
                    class="required">*</span></label>
            <select class="form-select" id="consulta" [(ngModel)]="newContact.type" required>
                <option value="" disabled i18n>Selecciona el tipo de consulta</option>
                <option value="Complaint" i18n>Queja</option>
                <option value="Suggestion" i18n>Sugerimiento</option>
                <option value="Information" i18n>Petición de información</option>
                <option value="Other" i18n>Otro</option>
            </select>
        </div>
        <div class="mb-3">
            <label for="suject" class="form-label"><span i18n>Asunto:</span><span class="required">*</span></label>
            <input type="text" class="form-control" id="suject" i18n-placeholder placeholder="Asunto"
                [(ngModel)]="newContact.subject" required />
        </div>
        <div class="mb-3">
            <label for="message" class="form-label"><span i18n>Mensaje:</span><span class="required">*</span></label>
            <textarea class="form-control" id="message" rows="5" i18n-placeholder placeholder="Escribe tu consulta aquí"
                [(ngModel)]="newContact.description"></textarea>
        </div>
        <div i18n>¿Por qué medio quiere ser comunicado?</div>
        <div class="mb-3">
            <div class="row">
                <div class="col-sm-12 col-md-6 mb-3">
                    <div class="row pt-2">
                        <div class="col-12">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="email-check"
                                    [(ngModel)]="newContact!.flagEmail">
                                <label class="form-check-label form-label" for="email-check" i18n>Recibir notificaciones por
                                    email</label>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="sms"
                                    [(ngModel)]="newContact!.flagSms">
                                <label class="form-check-label form-label" for="sms" i18n>Recibir notificaciones por sms</label>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="col-sm-12 col-md-6 mb-3">
                    <label for="language"><span i18n>Idioma notificación</span><span class="required">*</span>: </label>
                    <select class="form-select form-label" id="language" [(ngModel)]="newContact!.flagLanguage">
                        <option value="" i18n>Selecciona Idioma</option>
                        <option value="ca-ES" i18n>Catalan</option>
                        <option value="es-ES" i18n>Español</option>
                        <option value="en-GB" i18n>Ingles</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="mb-3">
            <label for="captcha" class="form-label"><span i18n>Captcha:</span><span class="required">*</span></label>
            <div class="d-flex flex-column align-items-start">
                <img [src]="captchaImage" alt="Captcha" />
                <div class="input-group">
                    <!-- Botón de recarga -->
                    <button class="btn btn-outline-secondary p-1" (click)="reloadCaptcha()"
                        aria-label="Recargar captcha">
                        <i class="bi bi-arrow-clockwise"></i>
                    </button>
                    <!-- Input del captcha -->
                    <input type="text" class="form-control" id="captcha" i18n-placeholder
                        placeholder="Introduce el captcha" [(ngModel)]="newContact.captcha.token" required />
                </div>
            </div>
        </div>
        <div class="mb-3 form-check">
            <p><b i18n>Protección de datos</b></p>
            <p><span i18n>La Autoridad del Transporte Metropolitano de Barcelona (ATM) le informa que sus datos serán tratados
                para gestionar sus solicitudes. Puede ejercer sus derechos y consultar la información adicional en
                nuestra </span> <a routerLink="/privacy" target="_blank" i18n>Política de Privacidad</a>.</p>

            <div class="ml-25 mb-1 check-legal">
                <input type="checkbox" class="form-check-input" id="data-protection"
                    [(ngModel)]="newContact.flagProtection" />
                <label class="form-check ml-3 p-0" for="data-protection"><span i18n>Acepto la </span><a routerLink="/privacy" target="_blank" i18n>Política de Privacidad</a></label>
            </div>
        </div>
        <button type="submit" class="btn btn-primary mr-3" (click)="createContact()" i18n>Enviar</button>
        <button type="reset" class="btn btn-secondary ml-3" (click)="resetForm()" i18n>Borrar</button>
    </div>
</main>